import { render, staticRenderFns } from "./LiveChallengeBanner.vue?vue&type=template&id=aba11efa&scoped=true&"
import script from "./LiveChallengeBanner.vue?vue&type=script&lang=js&"
export * from "./LiveChallengeBanner.vue?vue&type=script&lang=js&"
import style0 from "./LiveChallengeBanner.vue?vue&type=style&index=0&id=aba11efa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba11efa",
  null
  
)

export default component.exports